import { AirVent, ArrowRight, Bath, Building2, Check, Gauge, Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import { services } from "../data/siteContent";
import { usePublicContent } from "../hooks/use-public-content";

const icons = { bath: Bath, gauge: Gauge, "air-vent": AirVent, wrench: Wrench };
const serviceImages = [
  "/projects/ashford-the-triangle/first-fix.webp",
  "/projects/fendall-street/daikin-rooftop.webp",
  "/projects/fendall-street/risers.webp",
];

const getServiceImage = (service, index) => service.image || serviceImages[index] || serviceImages[serviceImages.length - 1];

export default function ServicesPage() {
  const { data } = usePublicContent();
  const displayedServices = data?.services?.length ? data.services.map((service) => ({ ...service, icon: icons[service.icon] || Wrench })) : services;
  return (
    <main className="v2-public v2-inner-page" data-testid="services-page">
      <section className="v2-page-hero v2-page-hero-split" data-testid="services-hero-section">
        <div><span className="v2-overline">Our services</span><h1 data-testid="services-title">Mechanical systems<br /><em>made to perform.</em></h1></div>
        <p data-testid="services-lead">Complete plumbing, heating and ventilation packages for residential construction—from coordinated first fix to tested, commissioned systems.</p>
      </section>
      <section className="v2-service-detail-list" data-testid="services-detail-section">
        {displayedServices.map((service, index) => (
          <article className="v2-service-detail" key={service.title} data-testid={`service-detail-${index + 1}`}>
            <div className="v2-service-detail-image"><img src={getServiceImage(service, index)} alt={service.title} /></div>
            <div className="v2-service-detail-copy"><div className="v2-service-number"><span>0{index + 1}</span><service.icon /></div><span className="v2-overline">Mechanical service</span><h2>{service.title}</h2><p>{service.description}</p><ul>{service.details.map((detail) => <li key={detail}><Check />{detail}</li>)}</ul></div>
          </article>
        ))}
      </section>
      <section className="v2-process-section" data-testid="service-process-section">
        <div className="v2-dark-heading"><span className="v2-overline">Our process</span><h2 data-testid="process-heading">Clear from coordination<br />to commissioning.</h2></div>
        <div className="v2-process-grid">
          {[['01', 'Understand', 'We listen to the needs of your home and clarify the practical requirements.'], ['02', 'Plan', 'We define the right mechanical approach and prepare for a clean installation.'], ['03', 'Deliver', 'We complete, test and check the work with attention to every visible detail.']].map(([number, title, text]) => <article key={number} data-testid={`process-step-${number}`}><span>{number}</span><h3>{title}</h3><p>{text}</p></article>)}
        </div>
      </section>
      <section className="v2-inline-cta" data-testid="services-cta-section"><Building2 /><div><span className="v2-overline">Planning a project?</span><h2 data-testid="services-cta-heading">Bring us into the conversation.</h2></div><Link to="/contact" className="v2-button-primary" data-testid="services-contact-link">Get in touch <ArrowRight /></Link></section>
    </main>
  );
}